import { readAuthData } from '@storage/auth';

import { ServiceAuthData, ServiceConfig, ServiceReturn } from '@types';

export function withAdminAuthData<R, P>(
  service: (
    payload: P,
    authData: ServiceAuthData,
    config?: ServiceConfig
  ) => ServiceReturn<R>,
  payload: P,
  config?: ServiceConfig
) {
  const authData = readAuthData();
  const accessToken = authData || '';

  return service(payload, { accessToken }, config);
}
